export const DemoBadge = ({ className = "" }) => (
  <span data-testid="demo-badge" className={`inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider bg-[#0E7C66]/10 text-[#0E7C66] px-2 py-0.5 rounded-full ${className}`}>
    Live
  </span>
);

export const TestModeBadge = ({ className = "" }) => (
  <span data-testid="test-mode-badge" className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider bg-[#F59E0B]/15 text-[#92400e] px-3 py-1 rounded-full border border-[#F59E0B]/30 ${className}`}>
    <span className="w-2 h-2 rounded-full bg-[#F59E0B]" /> Test Mode
  </span>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`bg-white rounded-3xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-[#111827]/5 ${className}`} {...rest}>
    {children}
  </div>
);

export const PageHeader = ({ title, subtitle }) => (
  <div className="px-5 pt-8 pb-4">
    <h1 className="text-3xl font-bold text-[#111827] font-head tracking-tight">{title}</h1>
    {subtitle && <p className="text-[#111827]/60 mt-1 text-base">{subtitle}</p>}
  </div>
);
